var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":_vm.link.path,"target":_vm.link.target,"href":_vm.link.path},nativeOn:{"click":function($event){return _vm.linkClick.apply(null, arguments)}}},[[_c('i',{class:_vm.link.icon}),_c('span',{staticClass:"nav-link-text"},[_vm._v(_vm._s(_vm.link.name))])]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }